import axios from 'axios';
import cookie from '../cookieHelper/cookie'; // Assuming you have a cookie helper

export default function getStoryInsightsV2(data, type) {
    let API_URL;
    let startDate = data.startDate || '';
    let endDate = data.endDate || '';

    // Construct API URL with query parameters
    API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/storyInsightsv2?type=${type}&startDate=${startDate}&endDate=${endDate}`;

    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);


    return (
        axios.get(API_URL, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
        })
        .then(res => {
            // console.log('res.data: ', res.data);
            return res.data;
        })
        .catch(err => {
            // console.error('Error fetching story insights: ', err);
            return err;
        })
    );
}
